import { Filter } from '@anytag/shared-molecules';
import { Template, TemplateProps } from './Template';
import { useInstagramHashtagsAnalyticsFilter } from './hooks';

export interface InstagramHashtagsAnalyticsFilterProps extends Pick<TemplateProps, 'hashtags'> {
  className?: string;
}

export const InstagramHashtagsAnalyticsFilter = ({
  className,
  ...templateProps
}: InstagramHashtagsAnalyticsFilterProps) => {
  const { filter, setFilterForm, countryId } = useInstagramHashtagsAnalyticsFilter();

  return (
    <Filter.Provider values={filter} onSubmit={setFilterForm} className="hashtag-filter-container">
      <Template {...templateProps} countryId={countryId} />
    </Filter.Provider>
  );
};

export * from './schemaTypes';
export { useInstagramHashtagsAnalyticsFilter };
